import { Component, OnInit } from '@angular/core';
import { FormComponentLookup } from '@ptl/forms';
import { setSEPLifeEventDocumentInfo } from 'src/app/angular-elements/shared/components/configs/reducers/life-event.reducer';
import { FileDisplayWithDropdownComponent } from '../../../required-docs-upload/file-display/variants/file-display-with-dropdown/file-display-with-dropdown.component';
import { SpecialEnrollmentEventDocumentUploadComponent } from '../../special-enrollment-event-document-upload.component';

// UNUSED
@FormComponentLookup('special-enrollment-event-document-upload-ichra-and-qsehra')
@Component({
    selector: 'app-special-enrollment-event-document-upload-ichra-and-qsehra',
    templateUrl: './../../special-enrollment-event-document-upload.component.html',
    styleUrls: [
        './../../special-enrollment-event-document-upload.component.scss',
        './special-enrollment-event-document-upload-ichra-and-qsehra.component.scss'
    ],
    standalone: false
})
export class SpecialEnrollmentEventDocumentUploadIchraAndQsehraComponent extends SpecialEnrollmentEventDocumentUploadComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  saveResponseToState(fileComponent: FileDisplayWithDropdownComponent) {

    this.ngRedux.dispatch(setSEPLifeEventDocumentInfo(
      fileComponent.displayableFileObj,
      fileComponent.dropdownControl.value
    ));

  }


}
